
import { Injectable, Component } from '@angular/core';
import { ConfigService } from "./ConfigService";


@Injectable()

export class UrlService {

    constructor(public configData: ConfigService) { }

    getURL(factoryName: string) {
        switch (factoryName) {
            default:
                return this.configData.baseUrl + 'api/' + factoryName;
        }
    }
}


